/**
 * Returns the Dashboard API URL, dynamically adjusting the hostname in development
 * to match the current browser hostname.
 *
 * This enables testing on mobile devices via network IP without changing env vars.
 * For example, if accessing the app at `192.168.1.100:3005`, API calls will
 * automatically target `192.168.1.100:3002` instead of `localhost:3002`.
 *
 * @returns The Dashboard API URL with the appropriate hostname
 */
const getDashboardApiUrl = (): string => {
  const envUrl = process.env.DASHBOARD_API_URL || 'http://localhost:3002';
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
      const url = new URL(envUrl);
      return `${url.protocol}//${currentHost}:${url.port}`;
    }
  }
  return envUrl;
};
const config = {
  dashboardApiUrl: getDashboardApiUrl(),
  mapboxApiKey: process.env.MAPBOX_API_KEY || '',
  stripePk: process.env.STRIPE_PK || '',
  // NOTE: ARC integration is deprecated - these are kept for backwards compatibility but not actively used
  // ARC_SUBSCRIPTION_KEY is intentionally NOT included as it's a secret and should never be exposed to frontend
  arcClientId: process.env.ARC_CLIENT_ID || '',
  arcApiUrl: process.env.ARC_API_URL || '',
  stripeConnectApiUrl: process.env.STRIPE_CONNECT_API_URL || '',
  stripeConnectClientId: process.env.STRIPE_CONNECT_CLIENT_ID || '',
  googleApiKey: process.env.GOOGLE_API_KEY || '',
  appSocialUrl: process.env.APP_SOCIAL_URL || 'http://localhost:3001',
  // NOTE: SENTRY_AUTH_TOKEN is intentionally NOT included here
  // It's only used by the webpack plugin during build time and should NEVER be exposed to the frontend
  commutifiEnv: process.env.COMMUTIFI_ENV || '',
  surveyDefaultBackgroundImage: process.env.SURVEY_DEFAULT_BACKGROUND_IMAGE || '',
  sentryTracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE ? parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE) : 0.1,
  // Sentry config
  sentryDSN: process.env.SENTRY_DSN,
  // @ts-expect-error -- Safety net: some build tools (e.g. webpack DefinePlugin) may inject a boolean instead of a string
  enableSentry: process.env.ENABLE_SENTRY === 'true' || process.env.ENABLE_SENTRY === true
};
export default config;